import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { getCategories } from "../actions/categories";
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    collection: []
  };

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      payload = _ref.payload,
      type = _ref.type;

  switch (type) {
    case getCategories.SUCCESS_TYPE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          collection: payload
        });
      }

    default:
      return state;
  }
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9yZWR1Y2Vycy9jYXRlZ29yaWVzLmpzIl0sIm5hbWVzIjpbImdldENhdGVnb3JpZXMiLCJzdGF0ZSIsImNvbGxlY3Rpb24iLCJwYXlsb2FkIiwidHlwZSIsIlNVQ0NFU1NfVFlQRSJdLCJtYXBwaW5ncyI6IjtBQUFBLFNBQVNBLGFBQVQ7QUFFQSxnQkFBZSxZQUFtRDtBQUFBLE1BQWxEQyxLQUFrRCx1RUFBMUM7QUFBRUMsSUFBQUEsVUFBVSxFQUFFO0FBQWQsR0FBMEM7O0FBQUE7QUFBQSxNQUFwQkMsT0FBb0IsUUFBcEJBLE9BQW9CO0FBQUEsTUFBWEMsSUFBVyxRQUFYQSxJQUFXOztBQUNoRSxVQUFRQSxJQUFSO0FBQ0UsU0FBS0osYUFBYSxDQUFDSyxZQUFuQjtBQUFpQztBQUMvQiwrQ0FDS0osS0FETDtBQUVFQyxVQUFBQSxVQUFVLEVBQUVDO0FBRmQ7QUFJRDs7QUFDRDtBQUNFLGFBQU9GLEtBQVA7QUFSSjtBQVVELENBWEQiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBnZXRDYXRlZ29yaWVzIH0gZnJvbSAnLi4vYWN0aW9ucy9jYXRlZ29yaWVzJztcblxuZXhwb3J0IGRlZmF1bHQgKHN0YXRlID0geyBjb2xsZWN0aW9uOiBbXSB9LCB7IHBheWxvYWQsIHR5cGUgfSkgPT4ge1xuICBzd2l0Y2ggKHR5cGUpIHtcbiAgICBjYXNlIGdldENhdGVnb3JpZXMuU1VDQ0VTU19UWVBFOiB7XG4gICAgICByZXR1cm4ge1xuICAgICAgICAuLi5zdGF0ZSxcbiAgICAgICAgY29sbGVjdGlvbjogcGF5bG9hZCxcbiAgICAgIH07XG4gICAgfVxuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4gc3RhdGU7XG4gIH1cbn07XG4iXX0=